import React from 'react';
import { PictoProps } from './index';

export const HowtoAdvantage2 = (props: PictoProps) => (
  <svg
    width="141"
    height="120"
    viewBox="0 0 141 120"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M38.9239 113.565C38.9239 113.565 90.3318 126.778 113.288 115.331C136.233 103.872 141.752 95.7311 137.776 80.3014C133.799 64.8843 130.939 64.6589 133.36 57.6078C135.793 50.5693 161.385 2.10119 101.145 0.122384C40.9059 -1.85642 33.6301 21.0501 33.4042 28.5395C33.1784 36.0289 34.734 54.5394 21.0478 63.1309C7.37415 71.7099 -2.33539 78.761 1.41545 92.1993C5.16629 105.638 38.9239 113.565 38.9239 113.565Z"
      fill="#E7F8F5"
    />
    <path
      d="M127.288 107.228C138.378 99.3631 140.749 91.8863 137.775 80.3015C133.924 65.3603 131.114 64.684 133.147 58.2592L2.06773 79.9759C0.449473 83.4826 0.0856791 87.4402 1.41541 92.1994C2.16809 94.9046 4.13759 97.3718 6.79705 99.6136C6.63397 99.4758 6.47089 99.3381 6.30781 99.2003L127.288 107.228Z"
      fill="#009989"
    />
    <path
      d="M28.6123 55.3285C27.9349 56.4557 27.1696 57.5578 26.2915 58.5847V100.54L28.537 100.678L28.6123 55.3285Z"
      fill="#037C72"
    />
    <path
      d="M26.2915 58.5847C24.8488 60.2755 23.1302 61.8159 21.0478 63.1184C7.37415 71.7099 -2.33539 78.761 1.41545 92.1993C2.11795 94.7292 3.89929 97.0712 6.30786 99.1877L26.304 100.528L26.2915 58.5847Z"
      fill="url(#paint0_linear_1251_110069)"
    />
    <path
      d="M26.2915 58.5847C24.8488 60.2755 23.1302 61.8159 21.0478 63.1184C7.37415 71.7099 -2.33539 78.761 1.41545 92.1993C2.11795 94.7292 3.89929 97.0712 6.30786 99.1877L26.304 100.528L26.2915 58.5847Z"
      fill="url(#paint1_linear_1251_110069)"
    />
    <path
      d="M19.5926 64.0453C6.68415 72.2235 -2.20999 79.2495 1.41541 92.1994C1.59104 92.8256 1.82938 93.4267 2.11791 94.0279H19.5926V64.0453Z"
      fill="#C2E1D8"
    />
    <path
      d="M12.6178 68.7042C3.71114 75.1541 -1.50742 81.7418 1.41547 92.1994C1.5911 92.8256 1.82945 93.4267 2.11797 94.0279H7.12328L12.6178 68.7042Z"
      fill="#E7F8F5"
    />
    <path
      d="M140.799 27.9009C140.761 26.8739 140.686 25.8344 140.548 24.8199H133.535C133.272 24.8199 133.046 25.0329 133.046 25.3084V27.425C133.046 27.688 133.259 27.9134 133.535 27.9134H140.799V27.9009Z"
      fill="#009989"
    />
    <path
      d="M46.25 50.5443H54.1907C54.4542 50.5443 54.68 50.7572 54.68 51.0327V53.1493C54.68 53.4123 54.4667 53.6378 54.1907 53.6378H46.25C45.9865 53.6378 45.7607 53.4248 45.7607 53.1493V51.0327C45.7607 50.7572 45.974 50.5443 46.25 50.5443Z"
      fill="#009989"
    />
    <path
      d="M38.3218 39.3979H46.2625C46.5259 39.3979 46.7517 39.6109 46.7517 39.8864V42.003C46.7517 42.266 46.5385 42.4914 46.2625 42.4914H38.3218C38.0583 42.4914 37.8325 42.2785 37.8325 42.003V39.8864C37.8325 39.6109 38.0583 39.3979 38.3218 39.3979Z"
      fill="#009989"
    />
    <path
      d="M129.12 83.3699H137.06C137.324 83.3699 137.55 83.5828 137.55 83.8583V85.9749C137.55 86.2379 137.336 86.4633 137.06 86.4633H129.12C128.856 86.4633 128.63 86.2504 128.63 85.9749V83.8583C128.63 83.5828 128.856 83.3699 129.12 83.3699Z"
      fill="#037C72"
    />
    <path
      d="M124.089 107.015V4.36809C118.382 1.976 110.892 0.435539 101.145 0.122437C85.7153 -0.391049 73.7728 0.74864 64.5149 2.82763V103.07L124.089 107.015Z"
      fill="url(#paint2_linear_1251_110069)"
    />
    <path
      d="M120.778 3.14074C115.559 1.46251 109.111 0.385442 101.145 0.122437C85.7153 -0.391049 73.7728 0.74864 64.5149 2.82763V23.4172L120.778 20.3237V3.14074Z"
      fill="url(#paint3_linear_1251_110069)"
    />
    <path d="M124.089 58.8603V34.1252H64.5149V58.8603H124.089Z" fill="#037C72" />
    <path
      d="M38.9239 113.565C38.9239 113.565 90.3318 126.778 113.288 115.331C118.996 112.476 123.625 109.833 127.301 107.228L18.564 100.002L6.30786 99.1876C16.6823 108.343 38.9239 113.565 38.9239 113.565Z"
      fill="#E7F8F5"
    />
    <path
      d="M18.5514 100.002L6.30786 99.1876C10.8616 103.208 17.7109 106.464 23.9456 108.856L28.5369 100.665L18.5514 100.002Z"
      fill="url(#paint4_linear_1251_110069)"
    />
    <path
      d="M44.8826 114.943C59.0831 117.999 95.1113 124.399 113.276 115.331C115.597 114.167 117.742 113.039 119.724 111.937L120.702 106.79L66.798 103.208L44.8826 114.943Z"
      fill="url(#paint5_linear_1251_110069)"
    />
    <path
      d="M83.9215 119.965C83.4197 116.897 82.9556 110.134 88.8014 110.046C96.3532 109.933 104.683 100.465 108.547 100.027C112.41 99.5885 126.423 97.8226 128.079 95.0673C129.659 92.4373 131.541 88.6049 138.528 92.6752C136.759 101.004 129.233 107.366 113.276 115.331C105.661 119.139 94.898 120.216 83.9215 119.965Z"
      fill="url(#paint6_radial_1251_110069)"
    />
    <path d="M114.38 40.3873V91.1473H71.5649V41.9779L114.38 40.3873Z" fill="#C2E1D8" />
    <path d="M114.38 40.3873V52.1725L71.5776 53.2996V41.9779L114.38 40.3873Z" fill="#A8D0CD" />
    <path
      d="M83.5073 91.1473H76.821L86.3675 41.4268L94.3083 41.1262L83.5073 91.1473Z"
      fill="#E7F8F5"
    />
    <path
      d="M84.1472 52.974L86.3676 41.4268L93.1041 41.1763L94.3084 41.1262L91.7994 52.7611L84.1472 52.974Z"
      fill="#B2DEDA"
    />
    <path
      d="M97.6326 91.1474H90.156L99.3136 40.9509L106.564 40.6754L97.6326 91.1474Z"
      fill="#E7F8F5"
    />
    <path
      d="M97.1812 52.6233L99.3137 40.9384L101.233 40.8632L106.577 40.6628L104.495 52.4229L97.1812 52.6233Z"
      fill="#B2DEDA"
    />
    <path
      d="M114.38 89.4941V91.1472H71.5649V41.9778L73.271 41.9152V89.4941H114.38Z"
      fill="#036159"
    />
    <path
      d="M120.778 3.14062V106.802L124.102 107.028V4.36798C123.048 3.92964 121.944 3.51635 120.778 3.14062Z"
      fill="#037C72"
    />
    <path
      d="M64.5148 23.4046L120.777 20.3237V40.1493L52.5974 42.6792L52.2712 36.2919L64.5148 23.4046Z"
      fill="url(#paint7_linear_1251_110069)"
    />
    <path
      d="M52.2588 36.2919L106.866 33.762L120.778 20.3237V40.1493L52.5975 42.6792L52.2588 36.2919Z"
      fill="url(#paint8_linear_1251_110069)"
    />
    <path d="M106.878 33.762V40.6628L120.778 40.1618V20.3237L106.878 33.762Z" fill="#036159" />
    <path
      d="M71.9539 94.1782V100.891L113.928 103.534V94.4412L71.9539 94.1782Z"
      fill="url(#paint9_linear_1251_110069)"
    />
    <path
      d="M71.9539 94.1782V100.891L113.928 103.534V102.807L73.4968 100.115V94.1782H71.9539Z"
      fill="#037C72"
    />
    <path
      d="M129.082 105.901C128.593 103.246 127.677 98.7995 126.95 98.1858C125.896 97.3091 123.7 97.0837 123.036 97.8602C122.371 98.6367 120.614 97.1964 120.502 96.5952C120.389 95.9941 123.374 92.1367 123.199 90.9218C123.036 89.707 118.457 85.5741 116.851 86.0249C115.245 86.4633 114.292 90.0952 112.184 88.0037C110.09 85.9122 112.849 85.2234 111.959 84.4218C111.081 83.6203 103.403 79.2745 100.204 80.9276C97.0055 82.5808 101.973 87.7532 102.299 88.9681C102.625 90.1829 103.792 91.9989 103.792 91.9989C103.792 91.9989 105.122 90.5712 105.611 91.1473C106.113 91.7234 106.991 92.3371 106.552 92.9883C106.113 93.6521 102.362 96.6829 102.525 97.5095C102.688 98.3361 105.837 103.458 106.326 103.509C106.815 103.559 109.575 102.018 110.19 102.081C110.792 102.131 112.235 104.335 111.959 104.836C111.683 105.337 109.086 108.142 109.312 108.806C109.538 109.47 113.69 115.081 113.715 115.118C120.201 111.862 125.256 108.869 129.082 105.901Z"
      fill="url(#paint10_linear_1251_110069)"
    />
    <path
      d="M122.571 110.297L122.584 110.284L122.647 110.246L122.659 110.234L122.734 110.184C121.957 107.929 119.786 102.319 115.597 96.5201C110.177 89.0056 105.649 85.3611 105.624 85.3611C105.536 85.286 105.398 85.2985 105.335 85.3862C105.26 85.4738 105.272 85.6116 105.36 85.6742C105.373 85.6867 109.864 89.2937 115.258 96.758C119.686 102.494 121.831 108.117 122.571 110.297Z"
      fill="url(#paint11_linear_1251_110069)"
    />
    <path
      d="M110.353 106.903C110.152 106.615 109.901 106.377 109.613 106.377C108.835 106.377 105.812 107.917 105.812 107.917C105.812 107.917 103.391 104.611 103.717 104.172C103.88 103.96 104.708 103.271 105.548 102.607C104.445 101.091 102.688 98.1108 102.563 97.4971C102.525 97.3218 102.663 97.0588 102.914 96.7331C101.961 95.869 101.145 95.2428 100.857 95.3054C99.9787 95.4682 96.7923 97.5221 96.5038 97.3719C96.2153 97.2216 94.7099 95.8815 94.873 95.4807C95.0361 95.08 95.4626 93.2264 95.4626 93.2264C95.4626 93.2264 86.6939 88.1416 85.2513 88.8179C83.8212 89.4942 86.4681 93.7774 87.296 96.1946C88.124 98.6117 88.4501 99.7138 89.0648 99.3882C89.667 99.0626 91.6616 98.4489 91.6616 98.4489C91.6616 98.4489 92.9286 101.48 92.5397 101.618C92.1508 101.755 88.0111 103.972 88.1742 104.623C88.2871 105.049 89.805 108.355 90.9089 110.547C91.072 110.409 91.2852 110.322 91.5487 110.284C92.339 110.196 93.0917 110.71 93.7816 111.562C94.8354 110.998 96.002 110.422 96.1525 110.585C96.4285 110.885 97.6704 114.142 97.4446 114.279C97.3443 114.342 96.6292 114.805 95.8515 115.294C96.5665 116.985 97.0808 118.65 97.3192 119.464C96.5038 119.552 95.6884 119.627 94.8604 119.69C101.81 119.151 108.246 117.824 113.301 115.306C114.267 114.83 115.195 114.354 116.098 113.879C115.333 114.279 114.556 114.68 113.753 115.081C113.728 115.056 109.575 109.433 109.349 108.769C109.224 108.481 109.738 107.704 110.353 106.903Z"
      fill="url(#paint12_linear_1251_110069)"
    />
    <path
      d="M105.9 117.999H105.912H105.925H105.937H105.95H105.962H105.975H105.987L106.151 117.961H106.163H106.176H106.188H106.201H106.213L106.339 117.924H106.351H106.364H106.376C104.946 115.081 101.133 107.554 98.5987 103.396C95.4375 98.1983 90.0809 93.2262 90.0684 93.2137C89.9805 93.1386 89.8551 93.1386 89.7798 93.2262C89.7046 93.3139 89.7046 93.4391 89.7924 93.5143C89.8049 93.5268 95.1238 98.4488 98.2475 103.609C100.681 107.679 104.444 115.093 105.9 117.999Z"
      fill="url(#paint13_linear_1251_110069)"
    />
    <path
      d="M121.555 101.467C121.405 102.118 121.505 102.87 121.944 103.521C122.371 104.135 122.76 104.999 123.086 105.901C123.224 106.264 123.337 106.627 123.45 106.978C123.738 107.904 123.964 108.769 124.089 109.332V109.345C123.713 109.583 123.324 109.821 122.923 110.071C122.797 110.146 122.684 110.221 122.559 110.284C121.33 111.023 120.025 111.762 118.632 112.526C118.507 112.588 118.382 112.664 118.256 112.726C120.376 111.574 122.321 110.447 124.077 109.345L124.089 109.382L124.14 109.345C125.206 108.681 126.26 107.98 127.276 107.253L127.301 107.241V107.216C127.301 107.203 127.301 107.203 127.301 107.191C127.163 106.051 126.862 104.272 126.285 102.782C125.883 101.768 125.356 100.878 124.641 100.415C124.453 100.29 124.265 100.19 124.077 100.114C123.625 99.9391 123.224 99.9141 122.86 100.002C122.521 100.089 122.233 100.265 122.007 100.528C121.806 100.791 121.643 101.116 121.555 101.467Z"
      fill="url(#paint14_linear_1251_110069)"
    />
    <path
      d="M98.3603 119.364C98.9248 116.283 99.3764 111.737 97.4194 110.91C94.9105 109.846 94.2456 117.009 94.4087 119.74C95.751 119.652 97.0682 119.527 98.3603 119.364Z"
      fill="url(#paint15_linear_1251_110069)"
    />
    <path
      d="M96.6541 119.552C96.9176 118.199 97.2061 116.609 97.2688 115.832C97.3943 114.354 97.4946 113.503 97.4946 113.503C97.5072 113.39 97.4319 113.29 97.319 113.265C97.2061 113.252 97.1058 113.327 97.0807 113.44C97.0807 113.44 96.9678 114.304 96.8423 115.795C96.7796 116.571 96.4785 118.224 96.2151 119.589C96.3656 119.577 96.5036 119.564 96.6541 119.552Z"
      fill="url(#paint16_linear_1251_110069)"
    />
    <path
      d="M125.821 108.243C125.683 108.33 125.545 108.43 125.394 108.518C125.419 107.917 125.432 106.239 124.817 104.648C124.039 102.657 123.675 102.181 123.675 102.181C123.613 102.093 123.625 101.956 123.713 101.893C123.801 101.83 123.939 101.843 124.002 101.93C124.002 101.93 124.403 102.444 125.206 104.498C125.758 105.951 125.833 107.454 125.821 108.243Z"
      fill="url(#paint17_linear_1251_110069)"
    />
    <path
      d="M97.3065 119.489C96.7043 117.41 94.3334 109.971 91.5234 110.297C88.6507 110.635 92.1757 117.924 93.5556 119.802C94.8227 119.727 96.0771 119.615 97.3065 119.489Z"
      fill="url(#paint18_linear_1251_110069)"
    />
    <path
      d="M95.2366 119.677H95.2492H95.2617H95.2743H95.2868H95.2994H95.3119H95.3244H95.337H95.3495H95.3621H95.3746H95.3872H95.3997H95.4122H95.4248H95.4373H95.4499H95.4624H95.475H95.4875H95.5001H95.5126H95.5252H95.5377H95.5502H95.5628H95.5753H95.5879H95.6004H95.613H95.6255H95.638H95.6506H95.6631H95.6757H95.6882H95.7008H95.7133H95.7259H95.7384H95.751H95.7635H95.776H95.7886H95.8011H95.8137H95.8262H95.8388H95.8513H95.8639H95.8764H95.8889H95.9015H95.914H95.9266H95.9391H95.9517C95.5126 118.35 94.6094 115.682 94.1327 114.68C93.5055 113.34 93.1668 112.538 93.1668 112.538C93.1291 112.438 93.0037 112.376 92.8908 112.426C92.7904 112.463 92.7402 112.589 92.7779 112.701C92.7779 112.701 93.104 113.503 93.7438 114.855C93.9069 115.782 94.785 118.325 95.2366 119.677Z"
      fill="url(#paint19_linear_1251_110069)"
    />
    <path
      d="M118.281 112.739C117.504 109.958 115.434 103.145 113.238 100.089C110.454 96.2194 110.441 96.2444 110.441 96.2444C110.341 96.1943 110.303 96.0691 110.353 95.9689C110.403 95.8687 110.529 95.8311 110.629 95.8812C110.629 95.8812 110.73 95.9063 113.577 99.8514C115.785 102.92 117.842 109.67 118.658 112.538C118.532 112.601 118.407 112.663 118.281 112.739Z"
      fill="url(#paint20_linear_1251_110069)"
    />
    <path
      d="M118.457 108.117C118.457 108.117 118.821 104.097 120.502 104.485C122.183 104.873 119.724 109.47 118.457 108.117Z"
      fill="url(#paint21_linear_1251_110069)"
    />
    <path
      d="M116.274 108.142C116.274 108.142 113.702 105.149 112.021 106.026C110.353 106.902 116.249 110.434 116.274 108.142Z"
      fill="url(#paint22_linear_1251_110069)"
    />
    <path
      d="M115.07 100.766C115.07 100.766 115.459 96.6077 116.776 96.7454C118.093 96.8832 116.412 102.031 115.07 100.766Z"
      fill="url(#paint23_linear_1251_110069)"
    />
    <path
      d="M113.163 100.991C113.163 100.991 109.939 99.4506 109.299 100.465C108.659 101.48 113.577 102.419 113.163 100.991Z"
      fill="url(#paint24_linear_1251_110069)"
    />
    <path
      d="M111.394 95.3677C111.394 95.3677 111.03 91.6606 112.385 91.9987C113.74 92.3369 112.36 96.5324 111.394 95.3677Z"
      fill="url(#paint25_linear_1251_110069)"
    />
    <path
      d="M109.826 96.5324C109.826 96.5324 106.715 95.4303 106.025 96.2569C105.323 97.0835 110.654 97.7723 109.826 96.5324Z"
      fill="url(#paint26_linear_1251_110069)"
    />
    <path
      d="M84.5235 58.0714L105.511 57.4327C105.849 57.4201 106.138 57.6957 106.15 58.0338L106.364 65.1725C106.376 65.5107 106.1 65.7987 105.762 65.8113L84.7744 66.45C84.4357 66.4625 84.1472 66.187 84.1346 65.8488L83.9214 58.7101C83.9214 58.372 84.1848 58.0839 84.5235 58.0714Z"
      fill="#009989"
    />
    <path
      d="M94.5466 48.4402C95.2115 48.4402 95.7509 48.9286 95.8262 49.5674C95.8889 49.63 95.9391 49.6926 95.9391 49.6926L99.1254 57.5827L98.9372 57.6579L95.8136 49.9681C95.7007 50.5693 95.1739 51.0327 94.5341 51.0327C93.9068 51.0327 93.3674 50.5818 93.2545 49.9806L90.3567 57.9334L90.156 57.8583L93.1291 49.6926L93.242 49.5674C93.3423 48.9411 93.8818 48.4402 94.5466 48.4402Z"
      fill="#037C72"
    />
    <path
      d="M89.2028 64.0452C88.8014 64.0577 88.4376 63.9701 88.1114 63.8073C87.7853 63.6444 87.5218 63.4065 87.3337 63.1059C87.1455 62.8053 87.0451 62.4672 87.0451 62.0789C87.0326 61.7032 87.1204 61.3525 87.296 61.052C87.4716 60.7389 87.7225 60.5009 88.0487 60.3256C88.3749 60.1502 88.7261 60.05 89.1275 60.05C89.529 60.0375 89.8928 60.1252 90.2189 60.288C90.5451 60.4508 90.796 60.6888 90.9967 60.9893C91.1849 61.2899 91.2852 61.6281 91.2978 62.0163C91.3103 62.392 91.2225 62.7427 91.0343 63.0433C90.8587 63.3564 90.6078 63.5944 90.2816 63.7697C89.968 63.945 89.6042 64.0327 89.2028 64.0452ZM89.1903 63.2812C89.4161 63.2812 89.6293 63.2186 89.8049 63.1184C89.9931 63.0057 90.1311 62.8554 90.2315 62.6676C90.3318 62.4797 90.382 62.2668 90.382 62.0288C90.382 61.7909 90.3193 61.578 90.2189 61.3901C90.106 61.2023 89.968 61.0645 89.7799 60.9518C89.5917 60.8516 89.391 60.8015 89.1526 60.8015C88.9268 60.8015 88.7136 60.8641 88.5379 60.9643C88.3498 61.077 88.2118 61.2273 88.1114 61.4152C88.0111 61.603 87.9609 61.8159 87.9609 62.0539C87.9609 62.2919 88.0236 62.5048 88.124 62.6926C88.2369 62.8805 88.3749 63.0182 88.563 63.131C88.7512 63.2312 88.9645 63.2812 89.1903 63.2812ZM93.6185 60.025C93.9572 60.025 94.2583 60.0751 94.5217 60.1753C94.7852 60.2755 94.9733 60.4383 95.1113 60.6512C95.2493 60.8641 95.3246 61.1021 95.3246 61.3901C95.3246 61.6782 95.2619 61.9287 95.1364 62.1416C94.9984 62.3545 94.8103 62.5173 94.5594 62.6425C94.3085 62.7552 94.0074 62.8179 93.6687 62.8304L92.8909 62.8429L92.9035 63.9075L92.0003 63.92L91.9375 60.05L93.6185 60.025ZM93.606 62.104C93.8694 62.104 94.0827 62.0414 94.2207 61.9161C94.3586 61.8034 94.4214 61.6281 94.4214 61.4152C94.4214 61.2023 94.3461 61.0269 94.2081 60.9142C94.0701 60.8015 93.8569 60.7514 93.5934 60.7514L92.8658 60.7639L92.8909 62.104H93.606ZM99.0002 63.0934L99.0127 63.8073L96.0145 63.8574L95.9393 59.9874L98.8747 59.9373L98.8873 60.6512L96.8425 60.6888L96.855 61.5279L98.6615 61.5028L98.674 62.2042L96.8676 62.2292L96.8801 63.131L99.0002 63.0934ZM103.215 59.8622L103.278 63.7321L102.538 63.7446L100.568 61.4277L100.606 63.7822L99.7152 63.7947L99.6525 59.9248L100.393 59.9123L102.362 62.2292L102.324 59.8747L103.215 59.8622Z"
      fill="#E7F8F5"
    />
    <path
      d="M111.231 116.258C110.554 114.029 109.387 110.56 108.145 108.844C106.238 106.201 106.238 106.214 106.238 106.214C106.163 106.176 106.138 106.089 106.176 106.026C106.213 105.951 106.301 105.926 106.364 105.963C106.364 105.963 106.427 105.976 108.371 108.681C109.626 110.422 110.805 113.904 111.495 116.145C111.407 116.183 111.332 116.221 111.231 116.258Z"
      fill="url(#paint27_linear_1251_110069)"
    />
    <path
      d="M111.72 114.329C111.72 114.329 111.971 111.587 113.113 111.85C114.254 112.1 112.586 115.244 111.72 114.329Z"
      fill="url(#paint28_linear_1251_110069)"
    />
    <path
      d="M110.228 114.342C110.228 114.342 108.471 112.3 107.33 112.889C106.176 113.49 110.202 115.907 110.228 114.342Z"
      fill="url(#paint29_linear_1251_110069)"
    />
    <path
      d="M109.4 109.295C109.4 109.295 109.663 106.452 110.566 106.552C111.47 106.652 110.315 110.159 109.4 109.295Z"
      fill="url(#paint30_linear_1251_110069)"
    />
    <path
      d="M108.095 109.445C108.095 109.445 105.887 108.393 105.461 109.082C105.021 109.783 108.383 110.434 108.095 109.445Z"
      fill="url(#paint31_linear_1251_110069)"
    />
    <path
      d="M106.891 105.613C106.891 105.613 106.64 103.083 107.568 103.308C108.496 103.546 107.543 106.402 106.891 105.613Z"
      fill="url(#paint32_linear_1251_110069)"
    />
    <path
      d="M105.812 106.401C105.812 106.401 103.679 105.65 103.215 106.214C102.738 106.777 106.376 107.253 105.812 106.401Z"
      fill="url(#paint33_linear_1251_110069)"
    />
    <defs>
      <linearGradient
        id="paint0_linear_1251_110069"
        x1="13.4486"
        y1="100.229"
        x2="13.4486"
        y2="66.0958"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#BFBFD6" />
        <stop offset="1" stopColor="#8A8EB3" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_1251_110069"
        x1="13.4557"
        y1="90.7197"
        x2="13.4557"
        y2="56.4911"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#88CAC3" />
        <stop offset="1" stopColor="#C6F2EE" />
      </linearGradient>
      <linearGradient
        id="paint2_linear_1251_110069"
        x1="94.3062"
        y1="81.9904"
        x2="94.3062"
        y2="-5.34178"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#88CAC3" />
        <stop offset="1" stopColor="#C6F2EE" />
      </linearGradient>
      <linearGradient
        id="paint3_linear_1251_110069"
        x1="92.6465"
        y1="27.9874"
        x2="92.6465"
        y2="1.37631"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#68C6BC" />
        <stop offset="1" stopColor="#C6F2EE" />
      </linearGradient>
      <linearGradient
        id="paint4_linear_1251_110069"
        x1="15.957"
        y1="97.4354"
        x2="21.6566"
        y2="107.19"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#71AEA9" />
        <stop offset="1" stopColor="#9ED7D2" />
      </linearGradient>
      <linearGradient
        id="paint5_linear_1251_110069"
        x1="88.1058"
        y1="96.0823"
        x2="78.5607"
        y2="124.74"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#51918C" />
        <stop offset="1" stopColor="#A2DBD6" />
      </linearGradient>
      <radialGradient
        id="paint6_radial_1251_110069"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(114.937 114.47) rotate(-38.9292) scale(70.9541 52.3255)"
      >
        <stop stopColor="#618700" />
        <stop offset="1" stopColor="#9DDB00" />
      </radialGradient>
      <linearGradient
        id="paint7_linear_1251_110069"
        x1="106.778"
        y1="30.8968"
        x2="59.6427"
        y2="32.3191"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#7ED1C8" />
        <stop offset="1" stopColor="#C1E8E4" />
      </linearGradient>
      <linearGradient
        id="paint8_linear_1251_110069"
        x1="100.979"
        y1="31.0468"
        x2="46.3856"
        y2="33.2942"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#77CAC2" />
        <stop offset="1" stopColor="#9CC9C5" />
      </linearGradient>
      <linearGradient
        id="paint9_linear_1251_110069"
        x1="79.9466"
        y1="97.4437"
        x2="97.6722"
        y2="98.2542"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#BDE5E2" />
        <stop offset="1" stopColor="#87C4BF" />
      </linearGradient>
      <linearGradient
        id="paint10_linear_1251_110069"
        x1="118.728"
        y1="103.236"
        x2="101.113"
        y2="79.6368"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#9DDB00" />
        <stop offset="1" stopColor="#FFFC36" />
      </linearGradient>
      <linearGradient
        id="paint11_linear_1251_110069"
        x1="118.973"
        y1="103.052"
        x2="101.358"
        y2="79.4537"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#A9E70C" />
        <stop offset="1" stopColor="#FFFF42" />
      </linearGradient>
      <linearGradient
        id="paint12_linear_1251_110069"
        x1="103.051"
        y1="113.527"
        x2="87.8744"
        y2="92.8155"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#7CAD00" />
        <stop offset="1" stopColor="#DFF125" />
      </linearGradient>
      <linearGradient
        id="paint13_linear_1251_110069"
        x1="103.925"
        y1="112.886"
        x2="88.748"
        y2="92.1752"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#88B90C" />
        <stop offset="1" stopColor="#EBFD31" />
      </linearGradient>
      <linearGradient
        id="paint14_linear_1251_110069"
        x1="122.521"
        y1="108.231"
        x2="118.927"
        y2="100.557"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#D8FF29" />
        <stop offset="1" stopColor="#E3FF95" />
      </linearGradient>
      <linearGradient
        id="paint15_linear_1251_110069"
        x1="96.4645"
        y1="121.561"
        x2="96.7709"
        y2="111.938"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#C9DB00" />
        <stop offset="1" stopColor="#D5FF6B" />
      </linearGradient>
      <linearGradient
        id="paint16_linear_1251_110069"
        x1="96.697"
        y1="121.569"
        x2="97.0033"
        y2="111.946"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#E1F318" />
        <stop offset="1" stopColor="#EDFF83" />
      </linearGradient>
      <linearGradient
        id="paint17_linear_1251_110069"
        x1="125.979"
        y1="108.24"
        x2="122.335"
        y2="98.9761"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#F0FF41" />
        <stop offset="1" stopColor="#FBFFAD" />
      </linearGradient>
      <linearGradient
        id="paint18_linear_1251_110069"
        x1="95.9993"
        y1="120.009"
        x2="91.4826"
        y2="111.502"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#D8FF29" />
        <stop offset="1" stopColor="#E2FF8E" />
      </linearGradient>
      <linearGradient
        id="paint19_linear_1251_110069"
        x1="96.1094"
        y1="119.95"
        x2="91.5926"
        y2="111.443"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#F0FF41" />
        <stop offset="1" stopColor="#FAFFA6" />
      </linearGradient>
      <linearGradient
        id="paint20_linear_1251_110069"
        x1="117.369"
        y1="108.748"
        x2="108.859"
        y2="93.7933"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#D8FF29" />
        <stop offset="1" stopColor="#E4FF9E" />
      </linearGradient>
      <linearGradient
        id="paint21_linear_1251_110069"
        x1="120.114"
        y1="107.186"
        x2="111.603"
        y2="92.2312"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#D8FF29" />
        <stop offset="1" stopColor="#E4FF9E" />
      </linearGradient>
      <linearGradient
        id="paint22_linear_1251_110069"
        x1="115.413"
        y1="109.862"
        x2="106.902"
        y2="94.9062"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#D8FF29" />
        <stop offset="1" stopColor="#E4FF9E" />
      </linearGradient>
      <linearGradient
        id="paint23_linear_1251_110069"
        x1="120.661"
        y1="106.875"
        x2="112.15"
        y2="91.9207"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#D8FF29" />
        <stop offset="1" stopColor="#E4FF9E" />
      </linearGradient>
      <linearGradient
        id="paint24_linear_1251_110069"
        x1="116.113"
        y1="109.463"
        x2="107.602"
        y2="94.5084"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#D8FF29" />
        <stop offset="1" stopColor="#E4FF9E" />
      </linearGradient>
      <linearGradient
        id="paint25_linear_1251_110069"
        x1="119.808"
        y1="107.36"
        x2="111.298"
        y2="92.4053"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#D8FF29" />
        <stop offset="1" stopColor="#E4FF9E" />
      </linearGradient>
      <linearGradient
        id="paint26_linear_1251_110069"
        x1="115.498"
        y1="109.813"
        x2="106.987"
        y2="94.8581"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#D8FF29" />
        <stop offset="1" stopColor="#E4FF9E" />
      </linearGradient>
      <linearGradient
        id="paint27_linear_1251_110069"
        x1="111.1"
        y1="114.68"
        x2="105.284"
        y2="104.46"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#D8FF29" />
        <stop offset="1" stopColor="#E4FF9E" />
      </linearGradient>
      <linearGradient
        id="paint28_linear_1251_110069"
        x1="112.847"
        y1="113.685"
        x2="107.031"
        y2="103.467"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#D8FF29" />
        <stop offset="1" stopColor="#E4FF9E" />
      </linearGradient>
      <linearGradient
        id="paint29_linear_1251_110069"
        x1="109.634"
        y1="115.514"
        x2="103.819"
        y2="105.294"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#D8FF29" />
        <stop offset="1" stopColor="#E4FF9E" />
      </linearGradient>
      <linearGradient
        id="paint30_linear_1251_110069"
        x1="113.22"
        y1="113.473"
        x2="107.404"
        y2="103.253"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#D8FF29" />
        <stop offset="1" stopColor="#E4FF9E" />
      </linearGradient>
      <linearGradient
        id="paint31_linear_1251_110069"
        x1="110.112"
        y1="115.241"
        x2="104.297"
        y2="105.022"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#D8FF29" />
        <stop offset="1" stopColor="#E4FF9E" />
      </linearGradient>
      <linearGradient
        id="paint32_linear_1251_110069"
        x1="112.638"
        y1="113.804"
        x2="106.822"
        y2="103.585"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#D8FF29" />
        <stop offset="1" stopColor="#E4FF9E" />
      </linearGradient>
      <linearGradient
        id="paint33_linear_1251_110069"
        x1="109.691"
        y1="115.48"
        x2="103.877"
        y2="105.261"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#D8FF29" />
        <stop offset="1" stopColor="#E4FF9E" />
      </linearGradient>
    </defs>
  </svg>
);
